export const GridAutoCompleteStyles = {
  gridAutoCompleteLableShrink: {
    "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
      transform: "translate(12px, 4px) scale(0.75)",
    },
  },
};
